<template>
  <div style="width: 100%; height: 180px; ">
    <!--  顶部蓝色区域  -->
    <div class="block_1 flex-row">
      <advance-search :dialogVisible="showAdSearch" @closeDialog="closeAdvanceSearch" @openLink="jumpgoStatic"></advance-search>
      <img
        class="image_1"
        referrerpolicy="no-referrer"
        src="../../src/assets/logo.png"
        @click="jumpgo('/nav')"
      />
      <div class="flex-row" v-if="!isSelect">
        <div class="group_1 flex-col"></div>
        <div class=" flex-row" :class="menuIndex == 0 ? 'group_2' : ''">
          <span :class="menuIndex == 0 ? 'text_1' : 'text_2'" @click.stop="jumpgo('/welcome')">Guess you like</span>
          <div class="block_2 flex-col"></div>
        </div>
        <div class=" flex-row" :class="menuIndex == 0 ? 'group_2' : ''">
          <span :class="menuIndex == 0 ? 'text_1' : 'text_2'" @click.stop="jumpgo('/goods?parentId=173&id=182')">Fabric</span>
          <div class="block_2 flex-col"></div>
        </div>
        <div class=" flex-row" :class="menuIndex == 1 ? 'group_2' : ''">
          <span :class="menuIndex == 1 ? 'text_1' : 'text_2'" @click.stop="jumpgo('/designlist?parentId=3&id=98')">style&nbsp;library</span>
          <div class="block_2 flex-col"></div>
        </div>
        <div class=" flex-row" :class="menuIndex == 2 ? 'group_2' : ''">
          <span :class="menuIndex == 2 ? 'text_1 ' : 'text_2'" @click.stop="jumpgo('/commonChanel')">Public&nbsp;Showroom</span>
          <div class="block_2 flex-col"></div>
        </div>
        <div class=" flex-row" :class="menuIndex == 3 ? 'group_2' : ''">
          <span :class="menuIndex == 3 ? 'text_1 ' : 'text_2'" @click.stop="jumpgo('/privateChanel')">Private&nbsp;Showroom</span>
          <div class="block_2 flex-col"></div>
        </div>
      </div>

      <div class="group_7 flex-col" @mouseenter="userInfoSel = true" @mouseleave="userInfoSel = false">
        <div class="text-wrapper_1 flex-col">
          <span class="text_8">VIP</span>
        </div>
        <div class="box_120 flex-col" v-if="userInfoSel">
          <div class="box_130 flex-row justify-between">
            <img
              class="label_20"
              referrerpolicy="no-referrer"
              src="../../src/assets/header/cricle.png"
            />
            <div class="block_10 flex-col justify-between">
              <span class="text_280">{{ this.userInfo.info.customerName }}</span>
              <div class="text-wrapper_40 flex-row justify-between">
                <span class="text_290">VIP</span>
                <span class="text_300">VIP</span>
              </div>
            </div>
          </div>
          <div class="box_140 flex-col"></div>
          <div :class="infoSel == 1 ? 'image-wrapper_10' : ''" @mouseenter="changeUserBtn(1)" @mouseleave="changeUserBtn(0)" @click="jumpgo('/userInfo')">
            <img
              class="image_30"
              referrerpolicy="no-referrer"
              src="../../src/assets/header/personcenter.png"
            />
          </div>
          <div :class="infoSel == 2 ? 'image-wrapper_10' : ''" @mouseenter="changeUserBtn(2)" @mouseleave="changeUserBtn(0)" @click="jumpgo('/privateChanel')">
            <img
              class="image_40"
              referrerpolicy="no-referrer"
              src="../../src/assets/header/privateshowroom.png"
            />
          </div>
          <div :class="infoSel == 3 ? 'image-wrapper_10' : ''" @mouseenter="changeUserBtn(3)" @mouseleave="changeUserBtn(0)" @click="jumpgo('/history')">
            <img
              class="image_50"
              referrerpolicy="no-referrer"
              src="../../src/assets/header/browsinghistory.png"
            />
          </div>
          <div :class="infoSel == 4 ? 'image-wrapper_10' : ''" @mouseenter="changeUserBtn(4)" @mouseleave="changeUserBtn(0)" @click="jumpgo('/setting')">
            <img
              class="image_60"
              referrerpolicy="no-referrer"
              src="../../src/assets/header/securitysettings.png"
            />
          </div>
          <div :class="infoSel == 5 ? 'image-wrapper_10' : ''" @mouseenter="changeUserBtn(5)" @mouseleave="changeUserBtn(0)" @click="jumpgo('/favorite')">
            <img
              class="image_70"
              referrerpolicy="no-referrer"
              src="../../src/assets/header/myfavorites.png"
            />
          </div>
          <div :class="infoSel == 6 ? 'image-wrapper_10' : ''" @mouseenter="changeUserBtn(6)" @mouseleave="changeUserBtn(0)" @click="_loginOut">
            <img
              class="image_80"
              referrerpolicy="no-referrer"
              src="../../src/assets/header/logout.png"
            />
          </div>
        </div>
      </div>
    </div>
    <!--  顶部蓝色区域  -->
    <div class="fenge"></div>
    <!--  面包屑  -->
    <div style="margin-left: 15%">
      <span class="text_655">Home&nbsp;&gt;</span>
      <span class="text_755">Public Showroom</span>
    </div>
    <!--  面包屑  -->
    <div class="fenge"></div>
    <!--  下方详细分类一级二级  -->
    <!--    <div class="group_1755 flex-row">-->
    <!--      <img-->
    <!--        class="thumbnail_155"-->
    <!--        referrerpolicy="no-referrer"-->
    <!--        src="../assets/cloth.png"-->
    <!--      />-->
    <!--      <span class="text_855">Fabric:</span>-->
    <!--      <div :class="item.entity.id == id ? `text-wrapper_855 flex-col` : `flex-col`" v-for="(item, i) in menuData" @click="parentMenuClick(item.entity.id)">-->
    <!--        <span :class="item.entity.id == id ? 'text_955_sel' : 'text_955' " >{{ item.entity.alias }}</span>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--    <div class="box_child" >-->
    <!--      <div :class="childId == item.id ? 'text-wrapper_555' : ''" v-for="(item, i) in menuChildren" style="display: inline-block">-->
    <!--        <span :class="childId == item.id ? 'box_child_font_sel' : 'box_child_font'" @click="jumpgo(`/goods?parentId=${id}&id=${item.id}`)">{{item.alias}}</span>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--    <div class="group_1755 flex-row" style="margin-top: 20px">-->
    <!--      <img-->
    <!--        class="thumbnail_155"-->
    <!--        referrerpolicy="no-referrer"-->
    <!--        src="../assets/brush.png"-->
    <!--      />-->
    <!--      <span class="text_855">Style:</span>-->
    <!--      <div :class="item.id == id ? `text-wrapper_855 flex-col` : `flex-col`" v-for="(item, i) in designMenu" @click="parentMenuClick(item.id)">-->
    <!--        <span :class="item.id == id ? 'text_955_sel' : 'text_955' " >{{ item.alias }}</span>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--    <div class="box_child">-->
    <!--      <div :class="childId == item.id ? 'text-wrapper_555' : ''" v-for="(item, i) in designMenuChildren"-->
    <!--           style="display: inline-block">-->
    <!--        <span :class="childId == item.id ? 'box_child_font_sel' : 'box_child_font'"-->
    <!--              @click="jumpgo(`/designlist?parentId=${id}&id=${item.id}`)">{{ item.alias }}</span>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>

<script>

import {getCartList, picSearch, getQuickSearch, getFavoriteSum} from '/api/goods'
import {getMenuName} from '/api/index.js'
import {loginOut, getFrontMenu, getMenuChildren, getFrontDesignMenu, getDesignMenuChildren} from '/api/index'
import {mapMutations, mapState} from 'vuex'
import {setStore, getStore, removeStore} from '/utils/storage'

import advanceSearch from '/components/advanceSearch-backup20230629'
export default {
  name: 'headerlist',
  data () {
    return {
      designMenu: [],
      designMenuChildren: [],
      childId: null,
      menuChildren: [],
      infoSel: 0,
      userInfoSel: false,
      menuIndex: -1,
      isSelect: false,
      favoriteSum: 0,
      cartSum: 0,
      id: null,
      showNav: false,
      showAdSearch: false,
      searchIpt: '',
      menuData: [],
      input: null,
      headerObj: {},
      // searchUrl: '',
      menuName: {
        parent: {
          id: null,
          name: null
        },
        child: {
          id: null,
          name: null
        }
      }
    }
  },
  created () {
    this.childId = this.$route.query.id
    this.id = this.$route.query.parentId + ''
    if (this.$route.path === '/commonChanel') {
      this.menuIndex = 2
    }
    if (this.$route.path === '/welcome') {
      this.menuIndex = -1
    }
    // if (this.id == null) {
    //   this.menuIndex = 0
    // }

    // switch (this.id) {
    //   case '62': this.menuIndex = 1
    //     break
    //   case '69': this.menuIndex = 2
    //     break
    //   case '71': this.menuIndex = 3
    //     break
    //   case '70': this.menuIndex = 4
    //     break
    // }
    this._getDesignMenu()
    this._getDesignMenuChildren()
  },
  mounted () {
    this.childId = this.$route.query.id
    this.id = this.$route.query.parentId + ''
    this.token = getStore('token')
    if (this.login) {
      this._getCartList()
    } else {
      this.INIT_BUYCART()
    }
    // this._getMenuName()
    this._getDesignMenu()

    // if (this.$route.path === '/goods') {
    //   this.showNav = true
    // }
    this._getDesignMenuChildren()
    setTimeout(() => {
      this.getCartSum()
    }, 500)
    this._getFavoriteSum()
  },
  updated () {
    this.getCartSum()
  },
  watch: {
    $route () {
      this.childId = this.$route.query.id
      this.id = this.$route.query.parentId + ''
      this._getDesignMenuChildren()
      this._getDesignMenu()

      if (this.childId == null) {
        this.jumpgo(`/designlist?parentId=${this.id}&id=${this.menuChildren[0].id}`)
      }
      // setTimeout(() => {
      //   if (this.childId == null) {
      //     this.jumpgo(`/goods?parentId=${this.id}&id=${this.menuChildren[0].id}`)
      //   }
      // }, 200)
      if (this.$route.path === '/goods') {
        this.showNav = true
      }
      this.getCartSum()
      // 路由发生变化页面刷新
      this.$router.go(0)
    }
  },
  computed: {
    ...mapState([
      'cartList', 'login', 'receiveInCart', 'showCart', 'userInfo'
    ])
  },
  methods: {
    ...mapMutations(['ADD_CART', 'INIT_BUYCART', 'ADD_ANIMATION', 'SHOW_CART', 'REDUCE_CART', 'RECORD_USERINFO', 'EDIT_CART']),
    _getMenuChildren () {
      let params = {
        id: this.id
      }
      getMenuChildren(params).then(res => {
        this.menuChildren = res.data
      })
    },
    _getDesignMenu () {
      getFrontDesignMenu().then(res => {
        this.designMenu = res
      })
    },
    _getDesignMenuChildren () {
      let params = {
        id: this.id
      }
      getDesignMenuChildren(params).then(res => {
        this.designMenuChildren = res.data
      })
    },
    _jumptoFirstChild () {
      let params = {
        id: this.id
      }
      getDesignMenuChildren(params).then(res => {
        this.designMenuChildren = res.data
        let chId = this.designMenuChildren[0].id
        // eslint-disable-next-line eqeqeq
        if (this.id === 4) {
          chId = 125
        }
        if (this.id === 3) {
          chId = 100
        }

        this.jumpgo(`/designlist?parentId=${this.id}&id=${chId}`)
      })
    },
    changeUserBtn (index) {
      this.infoSel = index
    },
    _getFavoriteSum () {
      getFavoriteSum({userId: getStore('userId')}).then(res => {
        this.favoriteSum = res.data
      })
    },
    say () {
      this.cartSum += 1
    },
    jumpgo (valurl) {
      const routeData = this.$router.resolve({
        path: valurl
      })
      window.open(routeData.href, '_blank')
    },
    getCartSum () {
      let sum = 0
      for (let i = 0; i < this.cartList.length; i++) {
        sum += this.cartList[i].cartProductList.length
      }
      this.cartSum = sum
    },

    _getMenuName () {
      if (this.$route.query.parentId != null) {
        this.menuName.parent.id = this.$route.query.parentId
        const params = {
          id: this.$route.query.parentId
        }
        getMenuName(params).then(res => {
          this.menuName.parent.name = res.data.alias
        })
        if (this.$route.query.id != null) {
          this.menuName.child.id = this.$route.query.id
          const params = {
            id: this.$route.query.id
          }
          getMenuName(params).then(res => {
            this.menuName.child.name = res.data.alias
          })
        } else {
          this.menuName.child.id = null
          this.menuName.child.name = null
        }
      } else {
        this.menuName.child.id = null
        this.menuName.child.name = null
        this.menuName.parent.id = null
        this.menuName.parent.name = null
      }
    },
    querySearchAsync (queryString, cb) {
      this.searchType = ''
      if (this.input === undefined) {
        cb([])
        return
      }
      this.input = this.input.trim()
      if (this.input === '') {
        cb([])
        return
      } else {
        this.loadAll(this.input)
        setTimeout(() => {
          cb(this.searchResults)
        }, 300)
      }
    },
    loadAll (keyinput) {
      let params = {
        params: {
          key: keyinput,
          sType: this.searchType
        }
      }
      getQuickSearch(params).then(res => {
        if (res === null || res === '') {
          return
        }
        // if (res.error) {
        //   this.showError(res.error.reason)
        //   return
        // }
        var array = []
        var maxSize = 10
        if (res.length <= 10) {
          maxSize = res.length
        }
        for (var i = 0; i < maxSize; i++) {
          var obj = {}
          obj.value = res[i]
          array.push(obj)
        }
        if (array.length !== 0) {
          this.searchResults = array
        } else {
          this.searchResults = []
        }
      })
    },
    handleIconClick (ev) {
      if (this.input === '') {
      } else {
        this.$router.push({
          path: '/goodSearch?r=' + Math.random() + '&cid=' + encodeURIComponent(this.input)
        })
      }
    },
    handleBeforeUpload (file) {
      let fileData = new FormData()
      fileData.append('file', file)
      fileData.append('pn', 0)
      fileData.append('rn', 20)
      picSearch(fileData)
        .then((res) => {
          let products = res.data.briefs.map(item => {
            return item.productId
          })
          products = (products.join(','))
          this.$router.push({path: '/goods?r=' + Math.random() + '&products=' + products})
        })
    },
    _getCartList () {
      this.customerName = this.userInfo.info.customerName
      getCartList({userId: getStore('userId')}).then(res => {
        if (res.code === 20007) {
          setStore('buyCart', res.data)
        }
        // 重新初始化一次本地数据
      }).then(this.INIT_BUYCART)
    },
    toUser () {
      this.$router.push({
        name: 'userInfo'
      })
    },
    goto (name) {
      this.$router.push({
        name: name
      })
    },
    parentMenuClick (parentId) {
      this.id = parentId

      this._jumptoFirstChild()
    },
    toNav () {
      this.$router.push({
        path: '/'
      })
    },
    jumpgoStatic (url, type) {
      this.$router.push({
        path: url,
        query: {
          type
        }
      })
    },
    jumpgoSearch (type) {
      this.$router.push({
        path: this.searchUrl,
        query: {
          type
        }
      })
    },
    jumpTo (url) {
      this.$router.push({
        name: url
      })
    },
    _getMenu () {
      getFrontMenu().then(
        res => {
          this.menuData = res
        }
      )
    },
    handleSelect (item) {
      this.input = item.value
    },
    _loginOut () {
      let params = {
        params: {
          token: this.token
        }
      }
      loginOut(params).then(res => {
        removeStore('buyCart')
        removeStore('commonTools')
        removeStore('token')
        removeStore('userId')
        removeStore('userInfo')
        // this.$router.push({
        //   path: '/refreshgoods'
        // })
        window.location.href = '/#/home'
      })
    },
    showAdvanceSearch () {
      this.showAdSearch = true
    },
    closeAdvanceSearch () {
      this.showAdSearch = false
    }
  },
  components: {
    advanceSearch
  }
}

</script>

<style scoped lang="scss">

body * {
  box-sizing: border-box;
  flex-shrink: 0;
}
body {
  font-family: PingFangSC-Regular, Roboto, Helvetica Neue, Helvetica, Tahoma,
  Arial, PingFang SC-Light, Microsoft YaHei;
}
input {
  background-color: transparent;
  border: 0;
}
button {
  margin: 0;
  padding: 0;
  border: 1px solid transparent;
  outline: none;
  background-color: transparent;
}

button:active {
  opacity: 0.6;
}
.van-nav-bar__left:active,
.van-nav-bar__right:active {
  opacity: 1;
}
[class*='van-']::after {
  border-bottom: 0;
}
.flex-col {
  display: flex;
  flex-direction: column;
}
.flex-row {
  display: flex;
  flex-direction: row;
}
.justify-start {
  display: flex;
  justify-content: flex-start;
}
.justify-center {
  display: flex;
  justify-content: center;
}

.justify-end {
  display: flex;
  justify-content: flex-end;
}
.justify-evenly {
  display: flex;
  justify-content: space-evenly;
}
.justify-around {
  display: flex;
  justify-content: space-around;
}
.justify-between {
  display: flex;
  justify-content: space-between;
}
.align-start {
  display: flex;
  align-items: flex-start;
}
.align-center {
  display: flex;
  align-items: center;
}
.align-end {
  display: flex;
  align-items: flex-end;
}

//-----------

.page {
  width: 100%;
  height: auto;
  overflow: hidden;
}

.box_1 {
  width: 100%;
  height: auto;
  background: url(../../src/assets/header/white.png)
  100% no-repeat;
  background-size: 100% 100%;
}

.block_1 {
  width: 100%;
  height: 80px;
  background: url(../../src/assets/header/header.png)
  100% no-repeat;
  background-size: 100% 100%;
}

.image_1 {
  width: 85px;
  height: 75px;
  margin: 3px 0 0 40px;
}

.group_1 {
  background-color: rgba(96, 120, 200, 1);
  width: 1px;
  height: 80px;
  margin-left: 40px;
}

.group_2 {
  width: auto;
  height: 80px;
  background: #3228CD
  100% no-repeat;
  background-size: 100% 100%;
}

.text_1 {
  width: auto;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 16px;
  font-family: SourceHanSansCN-Medium;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin: 33px 0 0 22px;
}

.block_2 {
  width: 11px;
  height: 7px;
  //background: url(../../src/assets/header/down.png) -1px -1px
  //no-repeat;
  background-size: 12px 8px;
  margin: 60px 5px 0 20px;
}

.text_2 {
  width: auto;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(229, 229, 229, 1);
  font-size: 16px;
  font-family: SourceHanSansCN-Medium;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin: 36px 0 0 57px;
}

.thumbnail_1 {
  width: 11px;
  height: 7px;
  margin: 40px 0 0 8px;
}

.text_3 {
  width: 36px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(229, 229, 229, 1);
  font-size: 16px;
  font-family: SourceHanSansCN-Medium;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin: 36px 0 0 68px;
}

.text_4 {
  width: 52px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(229, 229, 229, 1);
  font-size: 16px;
  font-family: SourceHanSansCN-Medium;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin: 36px 0 0 87px;
}

.thumbnail_2 {
  width: 11px;
  height: 7px;
  margin: 40px 0 0 10px;
}

.text_5 {
  width: 53px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(229, 229, 229, 1);
  font-size: 16px;
  font-family: SourceHanSansCN-Medium;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin: 35px 0 0 66px;
}

.text_6 {
  width: 71px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(229, 229, 229, 1);
  font-size: 16px;
  font-family: SourceHanSansCN-Medium;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin: 34px 0 0 85px;
}

.text_7 {
  width: 28px;
  height: 5px;
  overflow-wrap: break-word;
  color: rgba(229, 229, 229, 1);
  font-size: 24px;
  font-family: SourceHanSansCN-Bold;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin: 40px 0 0 86px;
}

.group_3 {
  width: 30px;
  height: 29px;
  background: url(../../src/assets/header/pic1.png) -5px -6px
  no-repeat;
  background-size: 40px 40px;
  margin: 27px 0 0 0;
  position: absolute;
  right: 500px;
}

.group_4 {
  width: 28px;
  height: 28px;
  background: url(../../src/assets/header/pic2.png) -6px -6px
  no-repeat;
  background-size: 40px 40px;
  margin: 27px 0 0 0;
  position: absolute;
  right: 400px;
}

.group_5 {
  width: 30px;
  height: 30px;
  background: url(../../src/assets/header/pic4.png) -5px -5px
  no-repeat;
  background-size: 40px 40px;
  margin: 12px 0 0 0;
  position: absolute;
  right: 300px;
}

.group_6 {
  width: 30px;
  height: 30px;
  background: url(../../src/assets/header/pic3.png) -4px -4px
  no-repeat;
  background-size: 40px 40px;
  margin: 27px 0 0 0;
  position: absolute;
  right: 200px;
}

.group_7 {
  height: 48px;
  background: url(../../src/assets/header/pic5.png)
  100% no-repeat;
  background-size: 100% 100%;
  width: 48px;
  margin: 20px 0 0 0;
  position: absolute;
  right: 100px;
}

.text-wrapper_1 {
  background-color: rgba(136, 77, 247, 1);
  border-radius: 6px;
  height: 12px;
  border: 1px solid rgba(255, 255, 255, 1);
  width: 27px;
  margin: 36px 0 0 11px;
}

.text_8 {
  width: 16px;
  height: 8px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 9px;
  font-family: OPPOSans-M;
  text-align: center;
  white-space: nowrap;
  line-height: 9px;
  margin: 2px 0 0 6px;
}

.block_3 {
  width: 100%;
  height: auto;
  margin-bottom: 1px;
  display:flex;
  flex-direction:column
}

.box_2 {
  width: 1920px;
  height: 547px;
  margin: 33px;
  align-self:center;
}

.group_8 {
  background-color: rgba(76, 72, 67, 1);
  border-radius: 16px;
  width: 253px;
  height: 541px;
}

.image-wrapper_1 {
  width: 1348px;
  height: 541px;
  margin-left: 33px;
}

.image_2 {
  width: 80px;
  height: 80px;
  margin: 231px 0 0 27px;
}

.image_3 {
  width: 81px;
  height: 80px;
  margin: 231px 34px 0 1126px;
}

.group_9 {
  background-color: rgba(76, 72, 67, 1);
  border-radius: 16px;
  width: 254px;
  height: 541px;
  margin: 6px 0 0 32px;
}

.box_3 {
  width: 1348px;
  height: 1px;
  margin: 22px 0 0 0;
  align-self: center;
}

.section_1 {
  background-color: rgba(238, 238, 242, 1);
  width: 1348px;
  height: 1px;
}

.text-wrapper_2 {
  width: 190px;
  height: 26px;
  margin: 28px 0 0 130px;
}

.text_9 {
  width: 190px;
  height: 26px;
  overflow-wrap: break-word;
  color: rgba(29, 33, 41, 1);
  font-size: 28px;
  font-family: SourceHanSansCN-Medium;
  text-align: left;
  white-space: nowrap;
  line-height: 38px;
  margin-left: 450px;

}

.box_4 {
  width: 1348px;
  height: 319px;
  margin: 16px 0 0 0;
  align-self: center;
}

.box_5 {
  border-radius: 10px;
  height: 318px;
  margin-top: 1px;
  width: 319px;
}

.image-wrapper_2 {
  width: 63px;
  height: 26px;
  margin: 12px 0 0 244px;

}

.image_4 {
  width: 63px;
  height: 26px;
}

.text-wrapper_3 {
  width: 159px;
  height: 44px;
  margin: 110px 0 126px 85px;
}

.paragraph_1 {
  width: 159px;
  height: 44px;
  overflow-wrap: break-word;
  color: rgba(55, 55, 55, 1);
  font-size: 18px;
  font-family: SourceHanSansCN-Medium;
  text-align: center;
  line-height: 14px;
}

.box_6 {
  border-radius: 10px;
  height: 318px;
  width: 319px;
  margin: 1px 0 0 24px;
}

.image-wrapper_3 {
  width: 295px;
  height: 40px;
  margin: 12px 0 0 12px;
}

.image_5 {
  width: 72px;
  height: 40px;
}

.label_1 {
  width: 40px;
  height: 40px;
}

.text-wrapper_4 {
  width: 200px;
  height: 44px;
  margin: 96px 0 126px 67px;
}

.paragraph_2 {
  width: 200px;
  height: 44px;
  overflow-wrap: break-word;
  color: rgba(55, 55, 55, 1);
  font-size: 18px;
  font-family: SourceHanSansCN-Medium;
  text-align: center;
  line-height: 14px;
}

.box_7 {
  border-radius: 10px;
  width: 319px;
  height: 318px;
  margin-left: 24px;
}

.block_4 {
  background-color: rgba(137, 77, 247, 1);
  border-radius: 8px;
  width: 72px;
  height: 40px;
  margin: 12px 0 0 12px;
}

.image-text_1 {
  width: 54px;
  height: 16px;
  margin: 13px 0 0 11px;
}

.text-group_1 {
  width: 26px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin-top: 2px;
}

.section_2 {
  background-color: rgba(255, 255, 255, 1);
  width: 1px;
  height: 16px;
  margin-left: 6px;
}

.section_3 {
  width: 14px;
  height: 14px;
  background: url(../../src/assets/header/pic6.png) -1px
  0px no-repeat;
  background-size: 15px 15px;
  margin: 1px 0 0 7px;
}

.label_2 {
  width: 41px;
  height: 41px;
  margin: 12px 12px 0 0;
}

.box_8 {
  border-radius: 10px;
  width: 319px;
  height: 318px;
  margin-left: 24px;
}

.box_9 {
  width: 1334px;
  height: 21px;
  margin: 16px 0 0 0;
  align-self: center;

}

.text_10 {
  width: 121px;
  height: 21px;
  overflow-wrap: break-word;
  color: rgba(29, 33, 41, 1);
  font-size: 22px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;

}

.image_6 {
  width: 21px;
  height: 11px;
  margin: 4px 0 0 127px;
}

.text_11 {
  width: 28px;
  height: 10px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 12px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin: 5px 0 0 8px;
}

.text_12 {
  width: 115px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(29, 33, 41, 1);
  font-size: 22px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 23px;
  margin-left: 33px;
}

.thumbnail_3 {
  width: 20px;
  height: 10px;
  margin: 4px 0 0 139px;
}

.text_13 {
  width: 28px;
  height: 10px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 12px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 23px;
  margin: 4px 0 0 8px;
}

.text_14 {
  width: 115px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(29, 33, 41, 1);
  font-size: 22px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin-left: 32px;
}

.box_10 {
  width: 20px;
  height: 10px;
  background: url(../../src/assets/header/pic7.png) -1px
  0px no-repeat;
  background-size: 21px 11px;
  margin: 3px 0 0 140px;
}

.text_15 {
  width: 28px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 12px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin: 3px 0 0 8px;
}

.text_16 {
  width: 115px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(29, 33, 41, 1);
  font-size: 22px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin-left: 32px;
}

.box_11 {
  width: 20px;
  height: 10px;
  background: url(../../src/assets/header/pic8.png) -1px
  0px no-repeat;
  background-size: 21px 11px;
  margin: 3px 0 0 140px;
}

.text_17 {
  width: 28px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 12px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin: 3px 0 0 8px;
}

.text-wrapper_5 {
  width: 1321px;
  height: 17px;
  margin: 6px 0 0 0;
  align-self: center;
}

.text_18 {
  width: 297px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(55, 55, 55, 1);
  font-size: 14px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin-top: 1px;
}

.text_19 {
  width: 297px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(55, 55, 55, 1);
  font-size: 14px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 23px;
  margin-left: 41px;
}

.text_20 {
  width: 296px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(55, 55, 55, 1);
  font-size: 14px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin-left: 46px;
}

.text_21 {
  width: 297px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(55, 55, 55, 1);
  font-size: 14px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin-left: 47px;
}

.box_12 {
  width: 1348px;
  height: 318px;
  margin: 32px 0 0 286px;
}

.group_10 {
  background-color: rgba(203, 203, 203, 1);
  border-radius: 10px;
  height: 318px;
  width: 319px;
}

.block_5 {
  width: 63px;
  height: 26px;
  margin: 12px 0 0 244px;
}

.text-wrapper_6 {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 13px;
  height: 26px;
  width: 63px;
}

.text_22 {
  width: 34px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(137, 77, 247, 1);
  font-size: 18px;
  font-family: SourceHanSansCN-Medium;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin: 9px 0 0 14px;
}

.text-wrapper_7 {
  width: 159px;
  height: 44px;
  margin: 111px 0 125px 85px;
}

.paragraph_3 {
  width: 159px;
  height: 44px;
  overflow-wrap: break-word;
  color: rgba(55, 55, 55, 1);
  font-size: 18px;
  font-family: SourceHanSansCN-Medium;
  text-align: center;
  line-height: 14px;
}

.group_11 {
  background-color: rgba(203, 203, 203, 1);
  border-radius: 10px;
  height: 318px;
  margin-left: 24px;
  width: 319px;
}

.group_12 {
  width: 295px;
  height: 40px;
  margin: 12px 0 0 12px;
}

.box_13 {
  background-color: rgba(137, 77, 247, 1);
  border-radius: 8px;
  width: 72px;
  height: 40px;
}

.image-text_2 {
  width: 54px;
  height: 16px;
  margin: 14px 0 0 11px;
}

.text-group_2 {
  width: 27px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: SourceHanSansCN-Medium;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin-top: 1px;
}

.box_14 {
  background-color: rgba(255, 255, 255, 1);
  width: 1px;
  height: 16px;
  margin-left: 5px;
}

.box_15 {
  width: 14px;
  height: 14px;
  background: url(../../src/assets/header/pic9.png)
  0px -1px no-repeat;
  background-size: 15px 15px;
  margin: 1px 0 0 7px;
}

.label_3 {
  width: 40px;
  height: 40px;
}

.text-wrapper_8 {
  width: 200px;
  height: 44px;
  margin: 97px 0 125px 67px;
}

.paragraph_4 {
  width: 200px;
  height: 44px;
  overflow-wrap: break-word;
  color: rgba(55, 55, 55, 1);
  font-size: 18px;
  font-family: SourceHanSansCN-Medium;
  text-align: center;
  line-height: 14px;
}

.group_13 {
  background-color: rgba(203, 203, 203, 1);
  border-radius: 10px;
  width: 319px;
  height: 318px;
  margin-left: 24px;
}

.group_14 {
  background-color: rgba(137, 77, 247, 1);
  border-radius: 8px;
  width: 72px;
  height: 40px;
  margin: 12px 0 0 12px;
}

.image-text_3 {
  width: 54px;
  height: 16px;
  margin: 13px 0 0 11px;
}

.text-group_3 {
  width: 26px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin-top: 1px;
}

.group_15 {
  background-color: rgba(255, 255, 255, 1);
  width: 1px;
  height: 16px;
  margin-left: 6px;
}

.group_16 {
  width: 14px;
  height: 14px;
  background: url(../../src/assets/header/pic10.png) -1px -1px
  no-repeat;
  background-size: 15px 15px;
  margin: 1px 0 0 7px;
}

.group_17 {
  width: 40px;
  height: 40px;
  background: url(../../src/assets/header/pic11.png) -1px -1px
  no-repeat;
  background-size: 41px 41px;
  margin: 12px 12px 0 0;
}

.group_18 {
  background-color: rgba(203, 203, 203, 1);
  border-radius: 10px;
  width: 319px;
  height: 318px;
  margin-left: 24px;
}

.box_16 {
  width: 1334px;
  height: 22px;
  margin: 16px 0 0 291px;
}

.text_23 {
  width: 121px;
  height: 22px;
  overflow-wrap: break-word;
  color: rgba(29, 33, 41, 1);
  font-size: 22px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
}

.thumbnail_4 {
  width: 20px;
  height: 10px;
  margin: 5px 0 0 127px;
}

.text_24 {
  width: 28px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 12px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin: 5px 0 0 9px;
}

.text_25 {
  width: 115px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(29, 33, 41, 1);
  font-size: 22px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 23px;
  margin: 1px 0 0 33px;
}

.thumbnail_5 {
  width: 20px;
  height: 10px;
  margin: 4px 0 0 139px;
}

.text_26 {
  width: 28px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 12px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 23px;
  margin: 4px 0 0 8px;
}

.text_27 {
  width: 115px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(29, 33, 41, 1);
  font-size: 22px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin-left: 32px;
}

.group_19 {
  width: 20px;
  height: 10px;
  background: url(../../src/assets/header/pic12.png) -1px -1px
  no-repeat;
  background-size: 21px 11px;
  margin: 4px 0 0 140px;
}

.text_28 {
  width: 28px;
  height: 10px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 12px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin: 4px 0 0 8px;
}

.text_29 {
  width: 115px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(29, 33, 41, 1);
  font-size: 22px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin-left: 32px;
}

.group_20 {
  width: 20px;
  height: 10px;
  background: url(../../src/assets/header/pic13.png) -1px -1px
  no-repeat;
  background-size: 21px 11px;
  margin: 4px 0 0 140px;
}

.text_30 {
  width: 28px;
  height: 10px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 12px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin: 4px 0 0 8px;
}

.text-wrapper_9 {
  width: 1321px;
  height: 17px;
  margin: 5px 0 0 290px;
}

.text_31 {
  width: 297px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(55, 55, 55, 1);
  font-size: 14px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin-top: 2px;
}

.text_32 {
  width: 297px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(55, 55, 55, 1);
  font-size: 14px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 23px;
  margin: 1px 0 0 41px;
}

.text_33 {
  width: 297px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(55, 55, 55, 1);
  font-size: 14px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin-left: 46px;
}

.text_34 {
  width: 297px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(55, 55, 55, 1);
  font-size: 14px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin-left: 46px;
}

.box_17 {
  width: 100%;
  height: 541px;
  margin: 54px 0 0 0;
  display:flex;
  flex-direction:column;
}

.group_21 {
  background-color: rgba(76, 72, 67, 1);
  border-radius: 16px;
  width: 1348px;
  height: 541px;
  align-self: center;
}

.box_18 {
  width: 1348px;
  height: 1px;
  margin: 32px 0 0 286px;
  align-self:center;
}

.box_19 {
  background-color: rgba(238, 238, 242, 1);
  width: 1348px;
  height: 1px;
}

.text-wrapper_10 {
  width: 190px;
  height: 26px;
  margin: 32px 0 0 287px;
}

.text_35 {
  width: 190px;
  height: 26px;
  overflow-wrap: break-word;
  color: rgba(29, 33, 41, 1);
  font-size: 28px;
  font-family: SourceHanSansCN-Medium;
  text-align: left;
  white-space: nowrap;
  line-height: 38px;
}

.box_20 {
  width: 1348px;
  height: 319px;
  margin: 16px 0 0 286px;
}

.section_4 {
  background-color: rgba(203, 203, 203, 1);
  border-radius: 10px;
  height: 318px;
  margin-top: 1px;
  width: 319px;
}

.box_21 {
  width: 63px;
  height: 26px;
  margin: 12px 0 0 244px;
}

.text-wrapper_11 {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 13px;
  height: 26px;
  width: 63px;
}

.text_36 {
  width: 34px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(137, 77, 247, 1);
  font-size: 18px;
  font-family: SourceHanSansCN-Medium;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin: 8px 0 0 14px;
}

.text-wrapper_12 {
  width: 159px;
  height: 44px;
  margin: 110px 0 126px 85px;
}

.paragraph_5 {
  width: 159px;
  height: 44px;
  overflow-wrap: break-word;
  color: rgba(55, 55, 55, 1);
  font-size: 18px;
  font-family: SourceHanSansCN-Medium;
  text-align: center;
  line-height: 14px;
}

.section_5 {
  background-color: rgba(203, 203, 203, 1);
  border-radius: 10px;
  height: 318px;
  width: 319px;
  margin: 1px 0 0 24px;
}

.group_22 {
  width: 295px;
  height: 40px;
  margin: 12px 0 0 12px;
}

.group_23 {
  background-color: rgba(137, 77, 247, 1);
  border-radius: 8px;
  width: 72px;
  height: 40px;
}

.image-text_4 {
  width: 54px;
  height: 16px;
  margin: 13px 0 0 11px;
}

.text-group_4 {
  width: 27px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: SourceHanSansCN-Medium;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin-top: 1px;
}

.box_22 {
  background-color: rgba(255, 255, 255, 1);
  width: 1px;
  height: 16px;
  margin-left: 5px;
}

.thumbnail_6 {
  width: 14px;
  height: 14px;
  margin: 1px 0 0 7px;
}

.label_4 {
  width: 40px;
  height: 40px;
}

.text-wrapper_13 {
  width: 200px;
  height: 44px;
  margin: 96px 0 126px 67px;
}

.paragraph_6 {
  width: 200px;
  height: 44px;
  overflow-wrap: break-word;
  color: rgba(55, 55, 55, 1);
  font-size: 18px;
  font-family: SourceHanSansCN-Medium;
  text-align: center;
  line-height: 14px;
}

.section_6 {
  background-color: rgba(203, 203, 203, 1);
  border-radius: 10px;
  width: 319px;
  height: 318px;
  margin-left: 24px;
}

.box_23 {
  background-color: rgba(137, 77, 247, 1);
  border-radius: 8px;
  width: 72px;
  height: 40px;
  margin: 12px 0 0 12px;
}

.image-text_5 {
  width: 54px;
  height: 16px;
  margin: 14px 0 0 11px;
}

.text-group_5 {
  width: 26px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin-top: 1px;
}

.block_6 {
  background-color: rgba(255, 255, 255, 1);
  width: 1px;
  height: 16px;
  margin-left: 6px;
}

.block_7 {
  width: 14px;
  height: 14px;
  background: url(../../src/assets/header/pic14.png) -1px
  0px no-repeat;
  background-size: 15px 15px;
  margin-left: 7px;
}

.box_24 {
  width: 40px;
  height: 40px;
  background: url(../../src/assets/header/pic11.png) -1px
  0px no-repeat;
  background-size: 41px 41px;
  margin: 12px 12px 0 0;
}

.section_7 {
  background-color: rgba(203, 203, 203, 1);
  border-radius: 10px;
  width: 319px;
  height: 318px;
  margin-left: 24px;
}

.box_25 {
  width: 1334px;
  height: 21px;
  margin: 16px 0 0 291px;
}

.text_37 {
  width: 121px;
  height: 21px;
  overflow-wrap: break-word;
  color: rgba(29, 33, 41, 1);
  font-size: 22px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
}

.group_24 {
  width: 20px;
  height: 10px;
  background: url(../../src/assets/header/pic7.png)
  0px -1px no-repeat;
  background-size: 21px 11px;
  margin: 5px 0 0 127px;
}

.text_38 {
  width: 28px;
  height: 10px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 12px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin: 5px 0 0 9px;
}

.text_39 {
  width: 115px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(29, 33, 41, 1);
  font-size: 22px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 23px;
  margin-left: 33px;
}

.thumbnail_7 {
  width: 20px;
  height: 10px;
  margin: 4px 0 0 139px;
}

.text_40 {
  width: 28px;
  height: 10px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 12px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 23px;
  margin: 4px 0 0 8px;
}

.text_41 {
  width: 115px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(29, 33, 41, 1);
  font-size: 22px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin-left: 32px;
}

.group_25 {
  width: 20px;
  height: 10px;
  background: url(../../src/assets/header/pic7.png) -1px
  0px no-repeat;
  background-size: 21px 11px;
  margin: 3px 0 0 140px;
}

.text_42 {
  width: 28px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 12px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin: 3px 0 0 8px;
}

.text_43 {
  width: 115px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(29, 33, 41, 1);
  font-size: 22px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin-left: 32px;
}

.group_26 {
  width: 20px;
  height: 10px;
  background: url(../../src/assets/header/pic7.png) -1px
  0px no-repeat;
  background-size: 21px 11px;
  margin: 3px 0 0 140px;
}

.text_44 {
  width: 28px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 12px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin: 3px 0 0 8px;
}

.text-wrapper_14 {
  width: 1321px;
  height: 17px;
  margin: 6px 0 0 290px;
}

.text_45 {
  width: 297px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(55, 55, 55, 1);
  font-size: 14px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin-top: 1px;
}

.text_46 {
  width: 297px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(55, 55, 55, 1);
  font-size: 14px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 23px;
  margin-left: 41px;
}

.text_47 {
  width: 296px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(55, 55, 55, 1);
  font-size: 14px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin-left: 46px;
}

.text_48 {
  width: 297px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(55, 55, 55, 1);
  font-size: 14px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin-left: 47px;
}

.box_26 {
  width: 1348px;
  height: 320px;
  margin: 31px 0 0 286px;
}

.box_27 {
  background-color: rgba(203, 203, 203, 1);
  border-radius: 10px;
  height: 318px;
  margin-top: 2px;
  width: 319px;
}

.group_27 {
  width: 63px;
  height: 26px;
  margin: 12px 0 0 244px;
}

.text-wrapper_15 {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 13px;
  height: 26px;
  width: 63px;
}

.text_49 {
  width: 34px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(137, 77, 247, 1);
  font-size: 18px;
  font-family: SourceHanSansCN-Medium;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin: 8px 0 0 14px;
}

.text-wrapper_16 {
  width: 159px;
  height: 44px;
  margin: 110px 0 126px 85px;
}

.paragraph_7 {
  width: 159px;
  height: 44px;
  overflow-wrap: break-word;
  color: rgba(55, 55, 55, 1);
  font-size: 18px;
  font-family: SourceHanSansCN-Medium;
  text-align: center;
  line-height: 14px;
}

.box_28 {
  background-color: rgba(203, 203, 203, 1);
  border-radius: 10px;
  height: 318px;
  width: 319px;
  margin: 2px 0 0 24px;
}

.section_8 {
  width: 295px;
  height: 40px;
  margin: 12px 0 0 12px;
}

.box_29 {
  background-color: rgba(137, 77, 247, 1);
  border-radius: 8px;
  width: 72px;
  height: 40px;
}

.image-text_6 {
  width: 54px;
  height: 16px;
  margin: 13px 0 0 11px;
}

.text-group_6 {
  width: 27px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: SourceHanSansCN-Medium;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin-top: 1px;
}

.box_30 {
  background-color: rgba(255, 255, 255, 1);
  width: 1px;
  height: 16px;
  margin-left: 5px;
}

.box_31 {
  width: 14px;
  height: 14px;
  background: url(../../src/assets/header/pic6.png)
  0px -1px no-repeat;
  background-size: 15px 15px;
  margin: 1px 0 0 7px;
}

.box_32 {
  width: 40px;
  height: 40px;
  background: url(../../src/assets/header/pic15.png)
  0px -1px no-repeat;
  background-size: 40px 41px;
}

.text-wrapper_17 {
  width: 200px;
  height: 44px;
  margin: 96px 0 126px 67px;
}

.paragraph_8 {
  width: 200px;
  height: 44px;
  overflow-wrap: break-word;
  color: rgba(55, 55, 55, 1);
  font-size: 18px;
  font-family: SourceHanSansCN-Medium;
  text-align: center;
  line-height: 14px;
}

.box_33 {
  background-color: rgba(203, 203, 203, 1);
  border-radius: 10px;
  width: 319px;
  height: 318px;
  margin-left: 24px;
}

.box_34 {
  background-color: rgba(137, 77, 247, 1);
  border-radius: 8px;
  width: 72px;
  height: 40px;
  margin: 12px 0 0 12px;
}

.image-text_7 {
  width: 54px;
  height: 16px;
  margin: 14px 0 0 11px;
}

.text-group_7 {
  width: 26px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin-top: 1px;
}

.section_9 {
  background-color: rgba(255, 255, 255, 1);
  width: 1px;
  height: 16px;
  margin-left: 6px;
}

.section_10 {
  width: 14px;
  height: 14px;
  background: url(../../src/assets/header/pic6.png) -1px -1px
  no-repeat;
  background-size: 15px 15px;
  margin: 1px 0 0 7px;
}

.box_35 {
  width: 40px;
  height: 40px;
  background: url(../../src/assets/header/pic11.png) -1px
  0px no-repeat;
  background-size: 41px 41px;
  margin: 12px 12px 0 0;
}

.box_36 {
  background-color: rgba(203, 203, 203, 1);
  border-radius: 10px;
  width: 319px;
  height: 318px;
  margin-left: 24px;
}

.box_37 {
  width: 1334px;
  height: 22px;
  margin: 15px 0 0 291px;
}

.text_50 {
  width: 121px;
  height: 22px;
  overflow-wrap: break-word;
  color: rgba(29, 33, 41, 1);
  font-size: 22px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
}

.thumbnail_8 {
  width: 20px;
  height: 10px;
  margin: 5px 0 0 127px;
}

.text_51 {
  width: 28px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 12px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin: 5px 0 0 9px;
}

.text_52 {
  width: 115px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(29, 33, 41, 1);
  font-size: 22px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 23px;
  margin: 1px 0 0 33px;
}

.box_38 {
  width: 20px;
  height: 10px;
  background: url(../../src/assets/header/pic7.png)
  0px -1px no-repeat;
  background-size: 20px 11px;
  margin: 5px 0 0 139px;
}

.text_53 {
  width: 28px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 12px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 23px;
  margin: 4px 0 0 8px;
}

.text_54 {
  width: 115px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(29, 33, 41, 1);
  font-size: 22px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin-left: 32px;
}

.box_39 {
  width: 20px;
  height: 10px;
  background: url(../../src/assets/header/pic7.png) -1px -1px
  no-repeat;
  background-size: 21px 11px;
  margin: 4px 0 0 140px;
}

.text_55 {
  width: 28px;
  height: 10px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 12px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin: 4px 0 0 8px;
}

.text_56 {
  width: 115px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(29, 33, 41, 1);
  font-size: 22px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin-left: 32px;
}

.box_40 {
  width: 20px;
  height: 10px;
  background: url(../../src/assets/header/pic7.png) -1px -1px
  no-repeat;
  background-size: 21px 11px;
  margin: 4px 0 0 140px;
}

.text_57 {
  width: 28px;
  height: 10px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 12px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin: 4px 0 0 8px;
}

.text-wrapper_18 {
  width: 1321px;
  height: 17px;
  margin: 5px 0 104px 290px;
}

.text_58 {
  width: 297px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(55, 55, 55, 1);
  font-size: 14px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin-top: 2px;
}

.text_59 {
  width: 297px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(55, 55, 55, 1);
  font-size: 14px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 23px;
  margin: 1px 0 0 41px;
}

.text_60 {
  width: 297px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(55, 55, 55, 1);
  font-size: 14px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin-left: 46px;
}

.text_61 {
  width: 297px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(55, 55, 55, 1);
  font-size: 14px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin-left: 46px;
}
.box_300 {
  background-color: rgba(123, 123, 242, 1);
  border-radius: 24px;
  width: 640px;
  height: 48px;
  justify-content: center;
  margin: 17px auto;
}

.section_100 {
  width: 18px;
  height: 18px;
  background: url(../../src/assets/header/pic16.png) -1px -1px
  no-repeat;
  background-size: 20px 20px;
  margin: 15px 0 0 20px;
}

.text_100 {
  width: 540px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(211, 211, 255, 1);
  font-size: 18px;
  font-family: OPPOSans-R;
  text-align: center;
  white-space: nowrap;
  line-height: 18px;
  margin: 16px 0 0 20px;
  position: relative;
  right: 20px;
}

.label_100 {
  width: 27px;
  height: 28px;
  margin: 10px 20px 0 0;
}


.box_120 {
  position: absolute;
  z-index: 99;
  right: -90px;
  top: 50px;
  width: 216px;
  height: 331px;
  background: url(../../src/assets/header/white3.png) -6px -6px
  no-repeat;
  background-size: 231px 346px;
}

.box_130 {
  width: 140px;
  height: 48px;
  margin: 12px 0 0 21px;
}

.label_20 {
  width: 48px;
  height: 48px;
}

.block_10 {
  width: 72px;
  height: 32px;
  margin-top: 11px;
}

.text_280 {
  width: 72px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(13, 12, 34, 1);
  font-size: 16px;
  font-family: OPPOSans-H;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
}

.text-wrapper_40 {
  width: 52px;
  height: 10px;
  margin-top: 7px;
}

.text_290 {
  width: 20px;
  height: 10px;
  overflow-wrap: break-word;
  color: rgba(75, 75, 214, 1);
  font-size: 12px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 12px;
}

.text_300 {
  width: 20px;
  height: 10px;
  overflow-wrap: break-word;
  color: rgba(170, 170, 170, 1);
  font-size: 12px;
  font-family: OPPOSans-M;
  text-align: left;
  white-space: nowrap;
  line-height: 12px;
}

.box_140 {
  background-color: rgba(229, 230, 235, 1);
  width: 175px;
  height: 1px;
  margin: 12px 0 0 21px;
}

.image_30 {
  width: 183px;
  height: 40px;
  margin: 6px 0 0 16px;
}

.image_40 {
  width: 183px;
  height: 41px;
  margin: -1px 0 0 16px;
}

.image_50 {
  width: 183px;
  height: 41px;
  margin: -1px 0 0 16px;
}

.image_60 {
  width: 183px;
  height: 41px;
  margin: -1px 0 0 16px;
}

.image_70 {
  width: 183px;
  height: 40px;
  margin: -1px 0 0 16px;
}

.image-wrapper_10 {
  height: 40px;
  background: url(../../src/assets/header/white2.png)
  100% no-repeat;
  background-size: 100% 100%;
  width: 183px;
  margin: 0 0 13px 16px;
}

.image_80 {
  width: 183px;
  height: 40px;
  margin: -1px 0 0 16px;
}

//---------------------------------
.fenge {
  background-color: rgba(243, 245, 247, 1);
  width: 70%;
  height: 6px;
  border: 2px solid rgba(229, 232, 239, 1);
  margin: 20px auto;
}
.box_155 {
  width: 1920px;
  height: 2033px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/ps07fdyf0k2cj7bj3gdqpcw0wr1vzvgrxysdb355d330-ead4-4333-9db4-cfc29c94e39a)
  100% no-repeat;
  background-size: 100% 100%;
}

.box_255 {
  width: 1920px;
  height: 80px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psq3rai31z9hl7z2720v4oh823g3e8o10e41bb92d3c-4738-4e4c-bda2-867ddeef68e8)
  100% no-repeat;
  background-size: 100% 100%;
}

.image_155 {
  width: 61px;
  height: 47px;
  margin: 17px 0 0 40px;
}

.group_155 {
  background-color: rgba(96, 120, 200, 1);
  width: 1px;
  height: 80px;
  margin-left: 40px;
}

.text-wrapper_155 {
  height: 80px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psm5nimlh93o0nmv8b2jmj94nyaufchij4e9a53a7d-a125-4568-b1b5-c1610bb8fca7)
  100% no-repeat;
  background-size: 100% 100%;
  width: 183px;
}

.text_155 {
  width: 49px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(243, 245, 247, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
  margin: 33px 0 0 67px;
}

.text_255 {
  width: 40px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(243, 245, 247, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
  margin: 36px 0 0 72px;
}

.text_355 {
  width: 146px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(243, 245, 247, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
  margin: 36px 0 0 90px;
}

.text_455 {
  width: 138px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(243, 245, 247, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
  margin: 36px 0 0 41px;
}

.text_555 {
  width: 28px;
  height: 5px;
  overflow-wrap: break-word;
  color: rgba(229, 229, 229, 1);
  font-size: 24px;
  font-family: SourceHanSansCN-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin: 40px 0 0 173px;
}

.label_155 {
  width: 30px;
  height: 29px;
  margin: 27px 0 0 705px;
}

.label_255 {
  width: 48px;
  height: 48px;
  margin: 16px 44px 0 40px;
}

.group_1455 {
  position: relative;
  width: 1920px;
  height: 1954px;
  margin-bottom: 1px;
}

.group_1555 {
  width: 118px;
  height: 15px;
  margin: 61px 0 0 292px;
}

.text-wrapper_255 {
  width: 118px;
  height: 15px;
  overflow-wrap: break-word;
  font-size: 0;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
}

.text_655 {
  width: 118px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
}

.text_755 {
  width: 118px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(29, 33, 41, 1);
  font-size: 16px;
  font-family: OPPOSans-B;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
}

.group_1655 {
  width: 1342px;
  height: 2px;
  margin: 16px 0 0 290px;
}

.section_155 {
  background-color: rgba(243, 245, 247, 1);
  width: 1346px;
  height: 6px;
  border: 2px solid rgba(229, 232, 239, 1);
  margin: -2px 0 0 -2px;
}

.group_1755 {
  //width: 1293px;
  width: 70%;
  height: auto;
  margin-left: 15%;
  overflow-wrap: break-word;
}

.thumbnail_155 {
  width: 20px;
  height: 18px;
  margin-top: 8px;
}

.text_855 {
  width: 66px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(29, 33, 41, 1);
  font-size: 20px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 8px 0 0 11px;
}

.text_955 {
  width: 112px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(13, 12, 34, 1);
  font-size: 20px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 20px;
  margin: 9px 0 0 10px;
}

.text_955_sel {
  width: 106px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 20px;
  margin: 8px 0 0 8px;
}

.text_1055 {
  width: 115px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(13, 12, 34, 1);
  font-size: 20px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 20px;
  margin: 9px 0 0 37px;
}

.text-wrapper_855 {
  background-color: rgba(75, 75, 214, 1);
  border-radius: 8px;
  height: 37px;
  margin-left: 28px;
  width: 124px;
}

.text_1155 {
  width: 105px;
  height: 22px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 20px;
  margin: 8px 0 0 8px;
}

.text_1255 {
  width: 70px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(13, 12, 34, 1);
  font-size: 20px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 20px;
  margin: 9px 0 0 26px;
}

.text_1355 {
  width: 71px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(13, 12, 34, 1);
  font-size: 20px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 20px;
  margin: 9px 0 0 35px;
}

.text_1455 {
  width: 47px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(13, 12, 34, 1);
  font-size: 20px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 20px;
  margin: 9px 0 0 36px;
}

.text_1555 {
  width: 60px;
  height: 22px;
  overflow-wrap: break-word;
  color: rgba(13, 12, 34, 1);
  font-size: 20px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 20px;
  margin: 11px 0 0 37px;
}

.text_1655 {
  width: 52px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(13, 12, 34, 1);
  font-size: 20px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 20px;
  margin: 12px 0 0 37px;
}

.text_1755 {
  width: 94px;
  height: 22px;
  overflow-wrap: break-word;
  color: rgba(13, 12, 34, 1);
  font-size: 20px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 20px;
  margin: 11px 0 0 36px;
}

.text_1855 {
  width: 116px;
  height: 22px;
  overflow-wrap: break-word;
  color: rgba(13, 12, 34, 1);
  font-size: 20px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 20px;
  margin: 11px 0 0 36px;
}

.group_1855 {
  width: 1328px;
  height: 2px;
  margin-left: 20.1%;
  margin-top: 4px;
}

.section_255 {
  height: 2px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/ps4lzzjzp41sos5fbhj6gbskliyy33553vmc7d399c7-00b6-4739-af5d-511eb2aede0f)
  0px 0px no-repeat;
  background-size: 1329px 2px;
  width: 1328px;
}

.box_1855 {
  background-color: rgba(75, 75, 214, 1);
  width: 124px;
  height: 3px;
  margin: -1px 0 0 413px;
}

.text-wrapper_955 {
  width: 1286px;
  height: 19px;
  margin: 14px 0 0 301px;
}

.text_1955 {
  width: 46px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
  margin-top: 1px;
}

.text_2055 {
  width: 49px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
  margin: 2px 0 0 28px;
}

.text_2155 {
  width: 51px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
  margin: 1px 0 0 28px;
}

.text_2255 {
  width: 105px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
  margin: 1px 0 0 28px;
}

.text_2355 {
  width: 48px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
  margin: 1px 0 0 28px;
}

.text_2455 {
  width: 88px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
  margin: 2px 0 0 27px;
}

.text_2555 {
  width: 54px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
  margin: 2px 0 0 28px;
}

.text_2655 {
  width: 151px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
  margin-left: 28px;
}

.text_2755 {
  width: 34px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
  margin: 2px 0 0 28px;
}

.text_2855 {
  width: 56px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
  margin: 3px 0 0 28px;
}

.text_2955 {
  width: 40px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
  margin: 2px 0 0 28px;
}

.text_3055 {
  width: 83px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
  margin: 1px 0 0 28px;
}

.text_3155 {
  width: 41px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
  margin: 2px 0 0 28px;
}

.text_3255 {
  width: 78px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
  margin: 1px 0 0 27px;
}

.group_1955 {
  width: 163px;
  height: 31px;
  margin: 5px 0 0 290px;
}

.text-wrapper_555 {
  border-radius: 15px;
  height: 31px;
  border: 1px solid rgba(75, 75, 214, 1);
  width: auto;
  text-align: center;
  padding-right: 15px;
  padding-left: 15px;
}

.text_3355 {
  width: 68px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(13, 12, 34, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
  margin: 7px 0 0 11px;
}

.text_3455 {
  width: 55px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
  margin-top: 6px;
}

.group_2055 {
  width: 507px;
  height: 22px;
  margin: 28px 0 0 292px;
}

.thumbnail_255 {
  width: 19px;
  height: 19px;
  margin-top: 1px;
}

.text_3555 {
  width: 54px;
  height: 22px;
  overflow-wrap: break-word;
  color: rgba(29, 33, 41, 1);
  font-size: 20px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 10px;
}

.text_3655 {
  width: 41px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(13, 12, 34, 1);
  font-size: 20px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 20px;
  margin: 1px 0 0 27px;
}

.text_3755 {
  width: 76px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(13, 12, 34, 1);
  font-size: 20px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 20px;
  margin: 1px 0 0 36px;
}

.text_3855 {
  width: 37px;
  height: 21px;
  overflow-wrap: break-word;
  color: rgba(13, 12, 34, 1);
  font-size: 20px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 37px;
}

.text_3955 {
  width: 31px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(13, 12, 34, 1);
  font-size: 20px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 36px;
}

.text_4055 {
  width: 66px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(13, 12, 34, 1);
  font-size: 20px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 37px;
}

.image-wrapper_355 {
  width: 1328px;
  height: 2px;
  margin: 14px 0 0 295px;
}

.image_255 {
  width: 1328px;
  height: 2px;
}

.text-wrapper_1055 {
  width: 1318px;
  height: auto;
  margin: 15px 0 0 301px;
  word-break: normal;
}

.text_4155 {
  width: 66px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
}

.text_4255 {
  width: 33px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
  margin: 1px 0 0 29px;
}

.text_4355 {
  width: 36px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
  margin: 1px 0 0 28px;
}

.text_4455 {
  width: 36px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
  margin: 1px 0 0 28px;
}

.text_4555 {
  width: 64px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
  margin: 1px 0 0 27px;
}

.text_4655 {
  width: 46px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
  margin: 1px 0 0 29px;
}

.text_4755 {
  width: 51px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
  margin: 1px 0 0 27px;
}

.text_4855 {
  width: 68px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
  margin: 1px 0 0 29px;
}

.text_4955 {
  width: 38px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
  margin-left: 28px;
}

.text_5055 {
  width: 30px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
  margin-left: 28px;
}

.text_5155 {
  width: 88px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
  margin: 1px 0 0 28px;
}

.text_5255 {
  width: 84px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
  margin-left: 29px;
}

.text_5355 {
  width: 104px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
  margin: 1px 0 0 28px;
}

.text_5455 {
  width: 73px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
  margin-left: 28px;
}

.text_5555 {
  width: 44px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
  margin: 1px 0 0 28px;
}

.text_5655 {
  width: 35px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(78, 89, 105, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
  margin: 1px 0 0 28px;
}

.group_2155 {
  width: 1342px;
  height: 2px;
  margin: 29px 0 0 290px;
}

.group_255 {
  background-color: rgba(243, 245, 247, 1);
  width: 1346px;
  height: 6px;
  border: 2px solid rgba(229, 232, 239, 1);
  margin: -2px 0 0 -2px;
}

.group_2255 {
  width: 1340px;
  height: 280px;
  margin: 24px 0 0 290px;
}

.group_355 {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 10px;
  width: 324px;
  height: 284px;
  border: 2px solid rgba(229, 232, 239, 1);
  margin: -2px 0 0 -2px;
}

.group_455 {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 10px;
  width: 324px;
  height: 284px;
  border: 2px solid rgba(229, 232, 239, 1);
  margin: -2px 0 0 16px;
}

.group_555 {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 10px;
  width: 324px;
  height: 284px;
  border: 2px solid rgba(229, 232, 239, 1);
  margin: -2px 0 0 16px;
}

.group_655 {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 10px;
  width: 324px;
  height: 284px;
  border: 2px solid rgba(229, 232, 239, 1);
  margin: -2px -2px 0 16px;
}

.group_2355 {
  width: 1288px;
  height: 42px;
  margin: 9px 0 0 290px;
}

.text-group_1355 {
  width: 268px;
  height: 42px;
}

.text_5755 {
  width: 109px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(13, 12, 34, 1);
  font-size: 20px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 1px;
}

.text_5855 {
  width: 268px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(132, 132, 142, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin-top: 9px;
}

.text-group_1455 {
  width: 268px;
  height: 42px;
  margin-left: 73px;
}

.text_5955 {
  width: 109px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(13, 12, 34, 1);
  font-size: 20px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 20px;
}

.text_6055 {
  width: 268px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(132, 132, 142, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin-top: 9px;
}

.text-group_1555 {
  width: 268px;
  height: 42px;
  margin-left: 72px;
}

.text_6155 {
  width: 109px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(13, 12, 34, 1);
  font-size: 20px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 1px;
}

.text_6255 {
  width: 268px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(132, 132, 142, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin-top: 9px;
}

.text-group_1655 {
  width: 268px;
  height: 42px;
  margin-left: 71px;
}

.text_6355 {
  width: 109px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(13, 12, 34, 1);
  font-size: 20px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 1px;
}

.text_6455 {
  width: 268px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(132, 132, 142, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin-top: 9px;
}

.group_2455 {
  width: 1590px;
  height: 331px;
  margin: 32px 0 0 290px;
}

.group_2555 {
  width: 320px;
  height: 331px;
}

.group_855 {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 10px;
  width: 324px;
  height: 284px;
  border: 2px solid rgba(229, 232, 239, 1);
  margin: -2px 0 0 -2px;
}

.text-group_1755 {
  width: 268px;
  height: 42px;
  margin-top: 7px;
}

.text_6555 {
  width: 109px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(13, 12, 34, 1);
  font-size: 20px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 1px;
}

.text_6655 {
  width: 268px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(132, 132, 142, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin-top: 9px;
}

.group_2655 {
  width: 320px;
  height: 331px;
  margin-left: 20px;
}

.block_155 {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 10px;
  width: 324px;
  height: 284px;
  border: 2px solid rgba(229, 232, 239, 1);
  margin: -2px 0 0 -2px;
}

.text-group_1855 {
  width: 268px;
  height: 42px;
  margin-top: 7px;
}

.text_6755 {
  width: 109px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(13, 12, 34, 1);
  font-size: 20px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 1px;
}

.text_6855 {
  width: 268px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(132, 132, 142, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin-top: 9px;
}

.group_2755 {
  width: 320px;
  height: 331px;
  margin-left: 20px;
}

.section_455 {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 10px;
  width: 324px;
  height: 284px;
  border: 2px solid rgba(229, 232, 239, 1);
  margin: -2px 0 0 -2px;
}

.text-group_1955 {
  width: 268px;
  height: 42px;
  margin-top: 7px;
}

.text_6955 {
  width: 109px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(13, 12, 34, 1);
  font-size: 20px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 1px;
}

.text_7055 {
  width: 268px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(132, 132, 142, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin-top: 9px;
}

.group_2855 {
  width: 320px;
  height: 331px;
  margin-left: 20px;
}

.box_1455 {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 10px;
  width: 324px;
  height: 284px;
  border: 2px solid rgba(229, 232, 239, 1);
  margin: -2px 0 0 -2px;
}

.text-group_2055 {
  width: 268px;
  height: 42px;
  margin-top: 7px;
}

.text_7155 {
  width: 109px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(13, 12, 34, 1);
  font-size: 20px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 1px;
}

.text_7255 {
  width: 268px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(132, 132, 142, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin-top: 9px;
}

.image_355 {
  width: 45px;
  height: 106px;
  margin: 194px 0 0 205px;
}

.group_2955 {
  width: 1340px;
  height: 280px;
  margin: 32px 0 0 290px;
}

.block_255 {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 10px;
  width: 324px;
  height: 284px;
  border: 2px solid rgba(229, 232, 239, 1);
  margin: -2px 0 0 -2px;
}

.block_355 {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 10px;
  width: 324px;
  height: 284px;
  border: 2px solid rgba(229, 232, 239, 1);
  margin: -2px 0 0 16px;
}

.block_455 {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 10px;
  width: 324px;
  height: 284px;
  border: 2px solid rgba(229, 232, 239, 1);
  margin: -2px 0 0 16px;
}

.block_555 {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 10px;
  width: 324px;
  height: 284px;
  border: 2px solid rgba(229, 232, 239, 1);
  margin: -2px -2px 0 16px;
}

.group_3055 {
  width: 1288px;
  height: 42px;
  margin: 9px 0 511px 290px;
}

.text-group_2155 {
  width: 268px;
  height: 42px;
}

.text_7355 {
  width: 109px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(13, 12, 34, 1);
  font-size: 20px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 1px;
}

.text_7455 {
  width: 268px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(132, 132, 142, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin-top: 9px;
}

.text-group_2255 {
  width: 268px;
  height: 42px;
  margin-left: 72px;
}

.text_7555 {
  width: 109px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(13, 12, 34, 1);
  font-size: 20px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 1px;
}

.text_7655 {
  width: 268px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(132, 132, 142, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin-top: 9px;
}

.text-group_2355 {
  width: 268px;
  height: 42px;
  margin-left: 72px;
}

.text_7755 {
  width: 109px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(13, 12, 34, 1);
  font-size: 20px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 1px;
}

.text_7855 {
  width: 268px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(132, 132, 142, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin-top: 9px;
}

.text-group_2455 {
  width: 268px;
  height: 42px;
  margin-left: 72px;
}

.text_7955 {
  width: 109px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(13, 12, 34, 1);
  font-size: 20px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 1px;
}

.text_8055 {
  width: 268px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(132, 132, 142, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin-top: 9px;
}

.box_1755 {
  position: absolute;
  left: 1663px;
  top: -5px;
  width: 216px;
  height: 331px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/ps8j8wxk8u5ft43dk83ridlqlg52fwk1fof1ba78dd-322e-4d85-a9a9-e1856e8555ce) -6px -6px
  no-repeat;
  background-size: 231px 346px;
}

.group_3155 {
  width: 140px;
  height: 48px;
  margin: 12px 0 0 21px;
}

.label_355 {
  width: 48px;
  height: 48px;
}

.text-wrapper_1155 {
  width: 72px;
  height: 32px;
  margin-top: 11px;
}

.text_8155 {
  width: 72px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(13, 12, 34, 1);
  font-size: 16px;
  font-family: OPPOSans-H;
  font-weight: 900;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
}

.text_8255 {
  width: 20px;
  height: 10px;
  overflow-wrap: break-word;
  color: rgba(75, 75, 214, 1);
  font-size: 12px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 12px;
  margin-top: 7px;
}

.group_1355 {
  background-color: rgba(229, 230, 235, 1);
  width: 175px;
  height: 1px;
  margin: 12px 0 0 21px;
}

.image_455 {
  width: 183px;
  height: 40px;
  margin: 6px 0 0 16px;
}

.image_555 {
  width: 183px;
  height: 41px;
  margin: -1px 0 0 16px;
}

.image_655 {
  width: 183px;
  height: 41px;
  margin: -1px 0 0 16px;
}

.image_755 {
  width: 183px;
  height: 41px;
  margin: -1px 0 0 16px;
}

.image-wrapper_455 {
  width: 183px;
  height: 80px;
  margin: -1px 0 13px 16px;
}

.image_855 {
  width: 183px;
  height: 40px;
  margin-top: 40px;
}

.image_955 {
  width: 183px;
  height: 40px;
  margin-left: -183px;
}
.box_child {
  margin-top: 10px;
  margin-left: 15%;
  height: auto;
  width: 70%;


}
.box_child_font {
  height: 17px;
  color: rgba(78, 89, 105, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 32px;
  margin-top: 10px;
  margin-left: 15px;
  margin-right: 15px;

}
.box_child_font_sel {
  color: rgba(13, 12, 34, 1);
  font-size: 16px;
  font-family: OPPOSans-M;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 32px;
  margin-top: 10px;

}
</style>




// WEBPACK FOOTER //
// headerChanelMenucommon.vue?8f10b74c